const notEmpty = (value, message) => {
  if (!value) return message;
  if (Array.isArray(value) && value.length === 0) return message;
  return null;
};

const validateScope = ({ services, projects, issue_types }) => {
  return {
    services: notEmpty(services, 'Please select at least one service'),
    projects: notEmpty(projects, 'Please select at least one project'),
    issue_types: notEmpty(issue_types, 'Please select at least one issue type'),
  };
};

const validateAutocreateIncidentBlock = (block, allowedServices) => {
  allowedServices = allowedServices || [];

  const result = {
    target_service: undefined,
    jql: undefined,
  };

  if (block && block.target_service && !allowedServices.find(s => s && s.id === block.target_service.id)) {
    result.target_service = `Selected service is not mapped by this rule`;
  }

  if (block && !block.on_create && !block.on_update && block.jql) {
    result.jql = `At least one checkbox should be checked`;
  }

  if (block && (block.on_create || block.on_update) && !block.jql) {
    result.jql = `JQL must not be empty`;
  }

  if (Object.values(result).every(val => !val)) return undefined;
  return result;
};

const validateAutocreateIncidents = ({ autocreate_incidents, autocreate_incidents_config, services }) => {
  if (!autocreate_incidents) return {};
  if (!Array.isArray(autocreate_incidents_config)) autocreate_incidents_config = [];
  const errors = autocreate_incidents_config.map(item => validateAutocreateIncidentBlock(item, services));
  if (errors.every(e => e === null)) return {};
  return { autocreate_incidents_config: errors };
};

const validateConfig = (config) => {
  return {
    ...validateScope(config),
    ...validateAutocreateIncidents(config, config),
  };
};

export const onValidate = (value) => {
  return {
    name: notEmpty(value.name, 'Can not be empty'),
    config: validateConfig(value.config || {})
  };
};
